/**
 * X6 Marketing Section - App Logic
 * All DOM queries are scoped to .x6-marketing-wrapper to prevent
 * interference with the rest of the Shopify theme.
 */
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.x6-marketing-wrapper');
  if (!wrapper) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Reveal on scroll ────────────────────────────────── */
  var revealItems = wrapper.querySelectorAll('.reveal');

  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach(function (item) { item.classList.add('is-visible'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12
    });

    revealItems.forEach(function (item) { revealObserver.observe(item); });
  }

  /* ── Display control tabs ────────────────────────────── */
  var displayData = {
    speed:  { code: 'H05', label: 'Speed level',   range: 'H01-H09', action: '＋ / − Adjust' },
    mode:   { code: 'P06', label: 'Training mode',  range: 'P01-P11', action: 'Press M' },
    volume: { code: 'U05', label: 'Volume level',   range: 'U01-U09', action: '＋ / − Adjust' }
  };

  var displayCode   = wrapper.querySelector('#displayCode');
  var displayLabel  = wrapper.querySelector('#displayLabel');
  var displayRange  = wrapper.querySelector('#displayRange');
  var displayAction = wrapper.querySelector('#displayAction');
  var controlTabs   = wrapper.querySelectorAll('.control-tab');

  controlTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var data = displayData[tab.dataset.display];
      controlTabs.forEach(function (item) {
        var active = item === tab;
        item.classList.toggle('active', active);
        item.setAttribute('aria-selected', String(active));
      });
      if (displayCode)   displayCode.textContent   = data.code;
      if (displayLabel)  displayLabel.textContent  = data.label;
      if (displayRange)  displayRange.textContent  = data.range;
      if (displayAction) displayAction.textContent = data.action;
    });
  });

  /* ── Feature rail slider ─────────────────────────────── */
  var featureRail = wrapper.querySelector('#featureRail');
  var featurePrev = wrapper.querySelector('#featurePrev');
  var featureNext = wrapper.querySelector('#featureNext');

  function scrollFeatures(direction) {
    if (!featureRail) return;
    var panel = featureRail.querySelector('.feature-panel');
    var gap   = Number.parseFloat(getComputedStyle(featureRail).columnGap) || 18;
    var distance = panel ? panel.getBoundingClientRect().width + gap : 560;
    featureRail.scrollBy({
      left: direction * distance,
      behavior: reducedMotion ? 'auto' : 'smooth'
    });
  }

  if (featurePrev) featurePrev.addEventListener('click', function () { scrollFeatures(-1); });
  if (featureNext) featureNext.addEventListener('click', function () { scrollFeatures(1); });

  /* ── FAQ accordion ───────────────────────────────────── */
  wrapper.querySelectorAll('.faq-list details').forEach(function (detail) {
    detail.addEventListener('toggle', function () {
      if (!detail.open) return;
      wrapper.querySelectorAll('.faq-list details').forEach(function (other) {
        if (other !== detail) other.open = false;
      });
    });
  });
});
